export class ImageUploadService {
    constructor(ApiService, Upload) {
        'ngInject';   
        
        this.apiService = ApiService;
        this._upload = Upload;
    }
    upload(details) {
        const resourceUrl = this.apiService.getResourceUrl('upload-image');
        return this._upload.upload({
            url: resourceUrl,
            data: {
                container: details.container,
                fileObj: (details.image instanceof File) ? details.image : this._upload.dataUrltoBlob(details.image, details.name)
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/common/libs/image-upload/image-upload.service.js